(() => {
  if (window.rgNamePersonalisationLoaded) return;
  window.rgNamePersonalisationLoaded = true;

  function initialise(box) {
    if (box.dataset.rgNameReady) return;
    const form = box.closest('form');
    if (!form) return;
    box.dataset.rgNameReady = '1';
    const input = box.querySelector('input[name^="properties["]');
    const error = box.querySelector('[data-rg-name-error]');
    const buy = form.querySelector('[data-rg-name-buy]');
    const personalisedIds = new Set(box.dataset.rgPersonalisedVariants.split('|').filter(Boolean));
    let active = false;
    let busy = false;
    const buttonRow = form.querySelector('.product-page-info__button-add-to-cart');
    if (buttonRow) buttonRow.insertAdjacentElement('afterend', buy);

    function selectedId() {
      const selector = form.querySelector('select[name="id"]');
      return selector?.value || form.querySelector('input[name="id"]')?.value ||
        form.querySelector('[name="variant_id"]')?.value || '';
    }
    function nativeBuyWrapper() {
      return form.querySelector('[data-js-product-button-dynamic-checkout]');
    }
    function sync() {
      active = personalisedIds.has(selectedId());
      box.hidden = !active;
      input.disabled = !active;
      input.required = active;
      buy.hidden = !active;
      const nativeBuy = nativeBuyWrapper();
      if (nativeBuy) nativeBuy.style.display = active ? 'none' : '';
      if (!active) {
        error.hidden = true;
        input.removeAttribute('aria-invalid');
      }
    }
    function valid() {
      sync();
      if (!active) return true;
      if (input.value.trim()) {
        error.hidden = true;
        input.removeAttribute('aria-invalid');
        input.value = input.value.trim();
        return true;
      }
      error.textContent = 'Please enter the ' + box.dataset.rgFieldLabel.toLowerCase() + ' before ordering.';
      error.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      input.focus({ preventScroll: true });
      return false;
    }
    function buyNow() {
      if (busy || !valid()) return;
      if (!form.reportValidity()) return;
      const variantId = selectedId();
      if (!variantId) return;
      if (!form.querySelector('[name="id"]')) {
        const variant = document.createElement('input');
        variant.type = 'hidden';
        variant.name = 'id';
        variant.dataset.rgNameVariant = '1';
        variant.value = variantId;
        form.append(variant);
      }
      let returnTo = form.querySelector('input[name="return_to"]');
      if (!returnTo) {
        returnTo = document.createElement('input');
        returnTo.type = 'hidden';
        returnTo.name = 'return_to';
        form.append(returnTo);
      }
      returnTo.value = (window.Shopify?.routes?.root || '/') + 'checkout';
      form.action = (window.Shopify?.routes?.root || '/') + 'cart/add';
      form.method = 'post';
      busy = true;
      HTMLFormElement.prototype.submit.call(form);
    }

    input.addEventListener('input', () => {
      if (input.value.trim()) {
        error.hidden = true;
        input.removeAttribute('aria-invalid');
      }
    });
    form.addEventListener('change', () => { sync(); requestAnimationFrame(sync); });
    form.addEventListener('click', event => {
      if (event.target.closest('[data-js-product-options]')) requestAnimationFrame(sync);
    });
    window.addEventListener('click', event => {
      const button = event.target.closest('button,input[type="submit"],[data-js-button-add-to-cart-clone]');
      if (!button || button.disabled) return;
      const sticky = button.matches('[data-js-button-add-to-cart-clone="footbar"]') &&
        !!form.querySelector('[data-js-trigger-id="add-to-cart"]');
      if (!sticky && button.form !== form) return;
      if (button === buy) {
        event.preventDefault();
        event.stopImmediatePropagation();
        buyNow();
        return;
      }
      if (!sticky && button.type !== 'submit') return;
      if (!valid()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    window.addEventListener('submit', event => {
      if (event.target !== form || valid()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
    window.addEventListener('pageshow', () => {
      busy = false;
      form.querySelector('input[name="return_to"]')?.remove();
      form.querySelector('input[name="id"][data-rg-name-variant]')?.remove();
      sync();
    });
    new MutationObserver(sync).observe(form, { childList: true, subtree: true });
    sync();
  }
  function initialiseAll() {
    document.querySelectorAll('[data-rg-name-personalisation]').forEach(initialise);
  }
  initialiseAll();
  document.addEventListener('shopify:section:load', initialiseAll);
})();
